// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-col {
  padding: 5px 2px;
}
.tab-col .list-box {
  max-height: 500px;
  overflow: scroll;
}

.model-box ion-label {
  font-size: 15px;
}
.model-box ion-label p {
  overflow: initial;
  white-space: pre-line;
  margin: 0;
}
.model-box ion-label.active {
  font-weight: bold;
}

.image-box {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 12px;
  overflow: hidden;
  background: #f7f7f7;
}
.image-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.image-box .placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}
.image-box ion-icon {
  font-size: 40px;
  color: #bbb;
  display: block;
  margin-bottom: 4px;
}

.selection-container {
  position: relative;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
}

.selectable-item {
  padding: 10px;
  margin: 5px;
  border: 1px solid #ccc;
}

.selectable-item.selected {
  background-color: #cce5ff;
  border-color: #3399ff;
}

.selection-box {
  position: absolute;
  border: 2px dashed #3399ff;
  background-color: rgba(51, 153, 255, 0.2);
  pointer-events: none;
}

/* ===== LOADING SCREEN STYLES ===== */
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #4facfe 75%, #00f2fe 100%);
  background-size: 400% 400%;
  animation: gradientShift 6s ease infinite;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.loading-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

/* Animated background circles */
.circles-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  animation: floatCircle 8s ease-in-out infinite;
}

.circle-1 {
  width: 300px;
  height: 300px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
  animation-duration: 10s;
}

.circle-2 {
  width: 200px;
  height: 200px;
  top: 60%;
  left: 70%;
  animation-delay: 2s;
  animation-duration: 12s;
}

.circle-3 {
  width: 150px;
  height: 150px;
  top: 20%;
  left: 80%;
  animation-delay: 4s;
  animation-duration: 8s;
}

.circle-4 {
  width: 250px;
  height: 250px;
  top: 70%;
  left: 15%;
  animation-delay: 1s;
  animation-duration: 11s;
}

@keyframes floatCircle {
  0%, 100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translate(50px, -50px) scale(1.2);
    opacity: 0.5;
  }
}
/* Main loader */
.main-loader {
  position: relative;
  width: 200px;
  height: 200px;
  margin-bottom: 40px;
}

.loader-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 4px solid transparent;
}

.loader-ring-1 {
  width: 180px;
  height: 180px;
  border-top-color: rgba(255, 255, 255, 0.8);
  border-right-color: rgba(255, 255, 255, 0.8);
  animation: spin 2s linear infinite;
}

.loader-ring-2 {
  width: 140px;
  height: 140px;
  border-bottom-color: rgba(255, 255, 255, 0.6);
  border-left-color: rgba(255, 255, 255, 0.6);
  animation: spin 3s linear infinite reverse;
}

.loader-ring-3 {
  width: 100px;
  height: 100px;
  border-top-color: rgba(255, 255, 255, 0.4);
  border-right-color: rgba(255, 255, 255, 0.4);
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
.loader-core {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
    box-shadow: 0 0 50px rgba(255, 255, 255, 0.5);
  }
}
.loader-icon {
  font-size: 40px;
  animation: bounce 1s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
/* Loading text */
.loading-text-container {
  text-align: center;
  margin-bottom: 30px;
}

.loading-title {
  font-size: 48px;
  font-weight: 700;
  color: white;
  margin: 0 0 20px 0;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
  animation: titleGlow 2s ease-in-out infinite;
}

@keyframes titleGlow {
  0%, 100% {
    text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
    transform: scale(1);
  }
  50% {
    text-shadow: 0 0 40px rgba(255, 255, 255, 0.8);
    transform: scale(1.02);
  }
}
.loading-subtitle {
  font-size: 24px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-letter {
  display: inline-block;
  animation: wave 1.5s ease-in-out infinite;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
}

.loading-letter:nth-child(1) {
  animation-delay: 0s;
}

.loading-letter:nth-child(2) {
  animation-delay: 0.1s;
}

.loading-letter:nth-child(3) {
  animation-delay: 0.2s;
}

.loading-letter:nth-child(4) {
  animation-delay: 0.3s;
}

.loading-letter:nth-child(5) {
  animation-delay: 0.4s;
}

.loading-letter:nth-child(6) {
  animation-delay: 0.5s;
}

.loading-letter:nth-child(7) {
  animation-delay: 0.6s;
}

@keyframes wave {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  50% {
    transform: translateY(-10px) scale(1.1);
    opacity: 0.8;
  }
}
.loading-dots {
  display: inline-flex;
  margin-left: 5px;
}

.dot {
  display: inline-block;
  margin: 0 2px;
  animation: dotBounce 1.4s ease-in-out infinite;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotBounce {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 1;
  }
  40% {
    transform: translateY(-15px);
    opacity: 0.5;
  }
}
/* Progress bar */
.progress-bar-container {
  width: 300px;
  height: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.8) 0%, rgb(255, 255, 255) 50%, rgba(255, 255, 255, 0.8) 100%);
  background-size: 200% 100%;
  border-radius: 3px;
  animation: progressMove 7s ease-out forwards, progressShine 1s linear infinite;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
}

@keyframes progressMove {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
@keyframes progressShine {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 200% 0%;
  }
}
/* Responsive adjustments */
@media (max-width: 768px) {
  .loading-title {
    font-size: 36px;
  }
  .loading-subtitle {
    font-size: 20px;
  }
  .main-loader {
    width: 150px;
    height: 150px;
  }
  .loader-ring-1 {
    width: 140px;
    height: 140px;
  }
  .loader-ring-2 {
    width: 100px;
    height: 100px;
  }
  .loader-ring-3 {
    width: 70px;
    height: 70px;
  }
  .loader-core {
    width: 60px;
    height: 60px;
  }
  .loader-icon {
    font-size: 30px;
  }
  .circle-1, .circle-2, .circle-3, .circle-4 {
    width: 150px;
    height: 150px;
  }
  .progress-bar-container {
    width: 250px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/pages/catalog-admin/catalog-admin.page.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACE;EACE,iBAAA;EACA,gBAAA;AACJ;;AAIE;EACE,eAAA;AADJ;AAGI;EACE,iBAAA;EACA,qBAAA;EACA,SAAA;AADN;AAKE;EACE,iBAAA;AAHJ;;AAQA;EACE,WAAA;EACA,YAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AANF;AAQE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AANJ;AASE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AAPJ;AAUE;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AARJ;;AAcA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;AAXF;;AAcA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;AAXF;;AAcA;EACE,yBAAA;EACA,qBAAA;AAXF;;AAcA;EACE,kBAAA;EACA,0BAAA;EACA,yCAAA;EACA,oBAAA;AAXF;;AAgBA,sCAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,oGAAA;EACA,0BAAA;EACA,yCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAbF;;AAgBA;EACE;IAAK,2BAAA;EAZL;EAaA;IAAM,6BAAA;EAVN;EAWA;IAAO,2BAAA;EARP;AACF;AAUA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AARF;;AAWA,gCAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AARF;;AAWA;EACE,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,8CAAA;AARF;;AAWA;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AARF;;AAWA;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AARF;;AAWA;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;AARF;;AAWA;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AARF;;AAWA;EACE;IACE,mCAAA;IACA,YAAA;EARF;EAUA;IACE,4CAAA;IACA,YAAA;EARF;AACF;AAWA,gBAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AATF;;AAYA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,6BAAA;AATF;;AAYA;EACE,YAAA;EACA,aAAA;EACA,0CAAA;EACA,4CAAA;EACA,kCAAA;AATF;;AAYA;EACE,YAAA;EACA,aAAA;EACA,6CAAA;EACA,2CAAA;EACA,0CAAA;AATF;;AAYA;EACE,YAAA;EACA,aAAA;EACA,0CAAA;EACA,4CAAA;EACA,oCAAA;AATF;;AAYA;EACE;IAAO,6CAAA;EARP;EASA;IAAK,+CAAA;EANL;AACF;AAQA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6CAAA;EACA,wCAAA;AANF;;AASA;EACE;IACE,yCAAA;IACA,6CAAA;EANF;EAQA;IACE,2CAAA;IACA,6CAAA;EANF;AACF;AASA;EACE,eAAA;EACA,yCAAA;AAPF;;AAUA;EACE;IAAW,wBAAA;EANX;EAOA;IAAM,4BAAA;EAJN;AACF;AAMA,iBAAA;AACA;EACE,kBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,8CAAA;EACA,4CAAA;AAJF;;AAOA;EACE;IACE,8CAAA;IACA,mBAAA;EAJF;EAMA;IACE,8CAAA;IACA,sBAAA;EAJF;AACF;AAOA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AALF;;AAQA;EACE,qBAAA;EACA,yCAAA;EACA,8CAAA;AALF;;AAQA;EAA+B,mBAAA;AAJ/B;;AAKA;EAA+B,qBAAA;AAD/B;;AAEA;EAA+B,qBAAA;AAE/B;;AADA;EAA+B,qBAAA;AAK/B;;AAJA;EAA+B,qBAAA;AAQ/B;;AAPA;EAA+B,qBAAA;AAW/B;;AAVA;EAA+B,qBAAA;AAc/B;;AAZA;EACE;IACE,iCAAA;IACA,UAAA;EAeF;EAbA;IACE,uCAAA;IACA,YAAA;EAeF;AACF;AAZA;EACE,oBAAA;EACA,gBAAA;AAcF;;AAXA;EACE,qBAAA;EACA,aAAA;EACA,8CAAA;AAcF;;AAXA;EAAoB,mBAAA;AAepB;;AAdA;EAAoB,qBAAA;AAkBpB;;AAjBA;EAAoB,qBAAA;AAqBpB;;AAnBA;EACE;IACE,wBAAA;IACA,UAAA;EAsBF;EApBA;IACE,4BAAA;IACA,YAAA;EAsBF;AACF;AAnBA,iBAAA;AACA;EACE,YAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;UAAA,0BAAA;AAqBF;;AAlBA;EACE,YAAA;EACA,sHAAA;EAIA,0BAAA;EACA,kBAAA;EACA,8EAAA;EACA,6CAAA;AAkBF;;AAfA;EACE;IAAO,SAAA;EAmBP;EAlBA;IAAK,WAAA;EAqBL;AACF;AAnBA;EACE;IAAK,0BAAA;EAsBL;EArBA;IAAO,4BAAA;EAwBP;AACF;AAtBA,2BAAA;AACA;EACE;IACE,eAAA;EAwBF;EArBA;IACE,eAAA;EAuBF;EApBA;IACE,YAAA;IACA,aAAA;EAsBF;EAnBA;IAAiB,YAAA;IAAc,aAAA;EAuB/B;EAtBA;IAAiB,YAAA;IAAc,aAAA;EA0B/B;EAzBA;IAAiB,WAAA;IAAa,YAAA;EA6B9B;EA3BA;IACE,WAAA;IACA,YAAA;EA6BF;EA1BA;IACE,eAAA;EA4BF;EAzBA;IACE,YAAA;IACA,aAAA;EA2BF;EAxBA;IACE,YAAA;EA0BF;AACF","sourcesContent":[".tab-col {\n  padding: 5px 2px;\n\n  .list-box {\n    max-height: 500px;\n    overflow: scroll;\n  }\n}\n\n.model-box {\n  ion-label {\n    font-size: 15px;\n\n    p {\n      overflow: initial;\n      white-space: pre-line;\n      margin: 0;\n    }\n  }\n\n  ion-label.active {\n    font-weight: bold;\n  }\n\n}\n\n.image-box {\n  width: 50px;\n  height: 50px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f7f7f7;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .placeholder {\n    text-align: center;\n    color: #888;\n    font-size: 14px;\n  }\n\n  ion-icon {\n    font-size: 40px;\n    color: #bbb;\n    display: block;\n    margin-bottom: 4px;\n  }\n}\n\n\n//selection-container\n.selection-container {\n  position: relative;\n  width: 100%;\n  user-select: none;\n}\n\n.selectable-item {\n  padding: 10px;\n  margin: 5px;\n  border: 1px solid #ccc;\n}\n\n.selectable-item.selected {\n  background-color: #cce5ff;\n  border-color: #3399ff;\n}\n\n.selection-box {\n  position: absolute;\n  border: 2px dashed #3399ff;\n  background-color: rgba(51, 153, 255, 0.2);\n  pointer-events: none;\n}\n\n\n\n/* ===== LOADING SCREEN STYLES ===== */\n.loading-screen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 9999;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #4facfe 75%, #00f2fe 100%);\n  background-size: 400% 400%;\n  animation: gradientShift 6s ease infinite;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n@keyframes gradientShift {\n  0% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n.loading-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n\n/* Animated background circles */\n.circles-container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.circle {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(5px);\n  animation: floatCircle 8s ease-in-out infinite;\n}\n\n.circle-1 {\n  width: 300px;\n  height: 300px;\n  top: 10%;\n  left: 10%;\n  animation-delay: 0s;\n  animation-duration: 10s;\n}\n\n.circle-2 {\n  width: 200px;\n  height: 200px;\n  top: 60%;\n  left: 70%;\n  animation-delay: 2s;\n  animation-duration: 12s;\n}\n\n.circle-3 {\n  width: 150px;\n  height: 150px;\n  top: 20%;\n  left: 80%;\n  animation-delay: 4s;\n  animation-duration: 8s;\n}\n\n.circle-4 {\n  width: 250px;\n  height: 250px;\n  top: 70%;\n  left: 15%;\n  animation-delay: 1s;\n  animation-duration: 11s;\n}\n\n@keyframes floatCircle {\n  0%, 100% {\n    transform: translate(0, 0) scale(1);\n    opacity: 0.3;\n  }\n  50% {\n    transform: translate(50px, -50px) scale(1.2);\n    opacity: 0.5;\n  }\n}\n\n/* Main loader */\n.main-loader {\n  position: relative;\n  width: 200px;\n  height: 200px;\n  margin-bottom: 40px;\n}\n\n.loader-ring {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  border: 4px solid transparent;\n}\n\n.loader-ring-1 {\n  width: 180px;\n  height: 180px;\n  border-top-color: rgba(255, 255, 255, 0.8);\n  border-right-color: rgba(255, 255, 255, 0.8);\n  animation: spin 2s linear infinite;\n}\n\n.loader-ring-2 {\n  width: 140px;\n  height: 140px;\n  border-bottom-color: rgba(255, 255, 255, 0.6);\n  border-left-color: rgba(255, 255, 255, 0.6);\n  animation: spin 3s linear infinite reverse;\n}\n\n.loader-ring-3 {\n  width: 100px;\n  height: 100px;\n  border-top-color: rgba(255, 255, 255, 0.4);\n  border-right-color: rgba(255, 255, 255, 0.4);\n  animation: spin 1.5s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: translate(-50%, -50%) rotate(0deg); }\n  to { transform: translate(-50%, -50%) rotate(360deg); }\n}\n\n.loader-core {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: translate(-50%, -50%) scale(1);\n    box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);\n  }\n  50% {\n    transform: translate(-50%, -50%) scale(1.1);\n    box-shadow: 0 0 50px rgba(255, 255, 255, 0.5);\n  }\n}\n\n.loader-icon {\n  font-size: 40px;\n  animation: bounce 1s ease-in-out infinite;\n}\n\n@keyframes bounce {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-10px); }\n}\n\n/* Loading text */\n.loading-text-container {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.loading-title {\n  font-size: 48px;\n  font-weight: 700;\n  color: white;\n  margin: 0 0 20px 0;\n  text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);\n  animation: titleGlow 2s ease-in-out infinite;\n}\n\n@keyframes titleGlow {\n  0%, 100% {\n    text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);\n    transform: scale(1);\n  }\n  50% {\n    text-shadow: 0 0 40px rgba(255, 255, 255, 0.8);\n    transform: scale(1.02);\n  }\n}\n\n.loading-subtitle {\n  font-size: 24px;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loading-letter {\n  display: inline-block;\n  animation: wave 1.5s ease-in-out infinite;\n  text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);\n}\n\n.loading-letter:nth-child(1) { animation-delay: 0s; }\n.loading-letter:nth-child(2) { animation-delay: 0.1s; }\n.loading-letter:nth-child(3) { animation-delay: 0.2s; }\n.loading-letter:nth-child(4) { animation-delay: 0.3s; }\n.loading-letter:nth-child(5) { animation-delay: 0.4s; }\n.loading-letter:nth-child(6) { animation-delay: 0.5s; }\n.loading-letter:nth-child(7) { animation-delay: 0.6s; }\n\n@keyframes wave {\n  0%, 100% {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: translateY(-10px) scale(1.1);\n    opacity: 0.8;\n  }\n}\n\n.loading-dots {\n  display: inline-flex;\n  margin-left: 5px;\n}\n\n.dot {\n  display: inline-block;\n  margin: 0 2px;\n  animation: dotBounce 1.4s ease-in-out infinite;\n}\n\n.dot:nth-child(1) { animation-delay: 0s; }\n.dot:nth-child(2) { animation-delay: 0.2s; }\n.dot:nth-child(3) { animation-delay: 0.4s; }\n\n@keyframes dotBounce {\n  0%, 80%, 100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n  40% {\n    transform: translateY(-15px);\n    opacity: 0.5;\n  }\n}\n\n/* Progress bar */\n.progress-bar-container {\n  width: 300px;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n  backdrop-filter: blur(5px);\n}\n\n.progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg,\n    rgba(255, 255, 255, 0.8) 0%,\n    rgba(255, 255, 255, 1) 50%,\n    rgba(255, 255, 255, 0.8) 100%);\n  background-size: 200% 100%;\n  border-radius: 3px;\n  animation: progressMove 7s ease-out forwards, progressShine 1s linear infinite;\n  box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);\n}\n\n@keyframes progressMove {\n  from { width: 0%; }\n  to { width: 100%; }\n}\n\n@keyframes progressShine {\n  0% { background-position: 0% 0%; }\n  100% { background-position: 200% 0%; }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .loading-title {\n    font-size: 36px;\n  }\n\n  .loading-subtitle {\n    font-size: 20px;\n  }\n\n  .main-loader {\n    width: 150px;\n    height: 150px;\n  }\n\n  .loader-ring-1 { width: 140px; height: 140px; }\n  .loader-ring-2 { width: 100px; height: 100px; }\n  .loader-ring-3 { width: 70px; height: 70px; }\n\n  .loader-core {\n    width: 60px;\n    height: 60px;\n  }\n\n  .loader-icon {\n    font-size: 30px;\n  }\n\n  .circle-1, .circle-2, .circle-3, .circle-4 {\n    width: 150px;\n    height: 150px;\n  }\n\n  .progress-bar-container {\n    width: 250px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
